import type { SchemaDeGarde } from '@repere/core';
import { nomDuDossier } from './prenoms';
import type { EnfantDuDossier } from './types';

/**
 * Le nom du dossier — un `<h1>` invisible, pour le plan du document.
 *
 * Le nom s'écrit dans le bandeau, à la place du mot-symbole (`Coquille.tsx`). Ce `<h1>`
 * reste ici, mais invisible : c'est le titre de la page au sens du plan du document, et le
 * bandeau — qui vit hors du `<main>` et se répète d'un écran à l'autre — n'est pas
 * l'endroit d'où un lecteur d'écran doit tirer la structure. Le dessin change, le plan ne
 * change pas.
 *
 * Le renommage a quitté ce composant : il vivait ici en texte (« Renommer »), à côté d'un
 * nom devenu invisible — deux choses qui n'avaient plus de raison d'être voisines. Il
 * reprendra sa place ailleurs, sous une autre forme.
 *
 * Le nom par défaut n'est **jamais enregistré** : il se recalcule à partir des prénoms et
 * du schéma en vigueur. Un enfant qui rejoint le dossier, un schéma qui change, et un nom
 * figé en base deviendrait faux sans que personne ne le sache.
 */
export function NomDuDossier({
  label,
  enfants,
  schema,
}: {
  label: string | null;
  enfants: EnfantDuDossier[];
  schema: SchemaDeGarde | null;
}) {
  return <h1 className="invisible">{nomDuDossier(label, enfants, schema)}</h1>;
}
